



































import Vue from 'vue';
import { defineComponent, ref, watch, computed, watchEffect, onMounted, Ref } from '@vue/composition-api';
import { generateRandomId } from '../helpers';
import { useWrapperClasses, useInputClasses, useDefaultInputFlags, useExposeFocus } from './abstractions';

export default defineComponent({
    props: {
        name: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            dafault: ''
        },
        error: {
            type: Object,
            default: null
        },
        placeholder: {
            type: String,
            default: ''
        },
        disabled: {
            type: [Boolean, String],
            default: false
        },
        readonly: {
            type: [Boolean, String],
            default: false
        },
        resetValue: {
            type: String,
            default: ''
        },
        showReset: {
            type: Boolean,
            default: false
        },
        actionSequentialFocus: {
            type: Boolean,
            default: false
        },
        focus: {
            type: Boolean,
            default: null
        }
    },

    model: { prop: 'value', event: 'update:value' },

    setup(props, context) {
        const inputElement = ref() as Ref<HTMLInputElement>;

        if (props.focus != null) {
            watchEffect(() => {
                if (inputElement.value != null) {
                    if (props.focus === true) {
                        inputElement.value.focus();
                    }
                    else if (props.focus === false) {
                        inputElement.value.blur();
                    }
                }
            });
            onMounted(() => {
                if (inputElement.value != null && props.focus == true) {
                    inputElement.value.focus();
                }
            });
        }

        const id = generateRandomId(props.name);

        const { isReadOnly, isDisabled } = useDefaultInputFlags(props);

        const { focused, onFocus, onBlur } = useExposeFocus(inputElement, context.emit, props);

        const hasActions = computed(() => props.showReset && !isReadOnly.value && !isDisabled.value);

        const formattedValue = computed(() => props.value || '');

        const onInput = (evt: Event) => {
            if (evt.target instanceof HTMLInputElement) {
                context.emit('update:value', evt.target.value);
            }
        }

        const onReset = () => {
            context.emit('update:value', props.resetValue);
        }

        return {
            inputElement,
            id,
            wrapperClasses : useWrapperClasses(props, context.attrs),
            inputClasses : useInputClasses('text', hasActions),
            formattedValue,
            hasActions,
            isReadOnly,
            isDisabled,
            onInput,
            onReset,
            onFocus,
            onBlur
        }
    }
})
